import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentPlanRequestPage } from './payment-plan-request.page';

const routes: Routes = [
  {
    path: '',
    component: PaymentPlanRequestPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class PaymentPlanRequestPageRoutingModule {}
